import { MetricsData, UserInfo } from "./types";

export class PerformanceTracker {
  private static hasBeenInitialized: boolean;

  private static isMetricsDataSended: boolean;

  private static metricsData: MetricsData = {};

  private static userInfo: UserInfo = {};

  public static init() {
    return;

    // ** Библиотека ожидает новой реализации, сейчас использование perfume.js не возможно
  }
}
